import { styled, TextField } from "@mui/material";
import { DateField } from "@mui/x-date-pickers";

export const StyledRangeField = styled("div", {
  shouldForwardProp: (prop: string) =>
    !["isFocused", "isDisabled", "hasValue", "isFullWidth"].includes(prop),
})<{
  isFocused?: boolean;
  isDisabled?: boolean;
  hasValue?: boolean;
  isFullWidth: boolean;
}>`
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  height: 2.286rem;
  width: ${({ isFullWidth }) => (isFullWidth ? "100%" : "19.286rem")};
  border-width: 1px;
  border-style: solid;
  border-radius: ${(props) => props.theme.wsc.radius.m};
  padding: 0 0 0 ${(props) => props.theme.wsc.spacing[1]};
  cursor: ${(props) => (props.isDisabled ? "default" : "text")};

  .clearButton {
    opacity: 1;
  }

  @media (pointer: fine) {
    .clearButton {
      opacity: 0;
    }

    &:hover .clearButton,
    &:focus-within .clearButton {
      opacity: 1;
    }
  }

  ${(props) =>
    props.isFocused
      ? `
  	color: ${props.theme.wsc.palette.neutral[props.hasValue ? 100 : 200]};
		border-color: ${props.theme.wsc.palette.neutral[props.hasValue ? 100 : 0]};
    background-color: ${
      props.theme.wsc.palette.neutral[props.hasValue ? 700 : 500]
    };
		
		input.MuiInputBase-input {
			color: ${props.theme.wsc.palette.neutral[props.hasValue ? 100 : 200]};

			&::placeholder,
			&::-ms-input-placeholder {
				color: ${props.theme.wsc.palette.neutral[props.hasValue ? 100 : 200]};
			}
		}
	`
      : props.isDisabled
        ? `
			color: ${props.theme.wsc.palette.neutral[300]};
			border-color: ${props.theme.wsc.palette.neutral[500]};
			background-color: ${props.theme.wsc.palette.neutral[800]};
	`
        : `
		color: ${props.theme.wsc.palette.neutral[props.hasValue ? 100 : 200]};
		border-color: ${props.theme.wsc.palette.neutral[props.hasValue ? 600 : 500]};
		background-color: ${props.theme.wsc.palette.neutral[700]};
	
		input.MuiInputBase-input {
			color: ${props.theme.wsc.palette.neutral[props.hasValue ? 100 : 200]};
			
		  &::placeholder,
		  &::-ms-input-placeholder {
      	color: ${props.theme.wsc.palette.neutral[props.hasValue ? 100 : 200]};
    	}
		}
	
		&:hover {
			background-color: ${props.theme.wsc.palette.neutral[600]};
			border-color: ${props.theme.wsc.palette.neutral[600]};
  	}
	`}

  &:has(.Mui-error) {
    border-color: ${(props) => props.theme.wsc.palette.warning[300]};
  }
`;

export const StyledRangeFieldBlock = styled("div")`
  display: flex;
  align-items: center;
`;

export const StyledRangeFieldDivider = styled("span")`
  padding: 0 0.143rem;
`;

export const StyledDateField = styled(DateField, {
  shouldForwardProp: (prop) => prop !== "isSpecificDate",
})<{
  isSpecificDate?: boolean;
}>`
  .MuiInputBase-root {
    padding: 0;

    &,
    &:focus,
    &:hover,
    &:visited,
    &.Mui-disabled {
      background: none;
    }

    &::before,
    &::after {
      content: none;
    }
  }

  .MuiFormLabel-root {
    text-overflow: initial;
  }

  .MuiInputBase-input {
    ${(props) => props.theme.wsc.typography.body1};
    color: ${(props) => props.theme.wsc.palette.neutral[200]};
    padding: 0;
    width: calc(
      ${(props) => props.theme.wsc.size.s} *
        ${(props) => (props.isSpecificDate ? 13 : 11)}
    );
    text-align: center;

    &::placeholder,
    &::-ms-input-placeholder {
      color: ${(props) => props.theme.wsc.palette.neutral[200]};
      opacity: 1;
    }

    &:focus {
      background: none;
    }

    &:disabled,
    &.Mui-disabled {
      background: none;
      -webkit-text-fill-color: unset;
      color: ${(props) => props.theme.wsc.palette.neutral[300]};

      &::placeholder,
      &::-ms-input-placeholder {
        color: ${(props) => props.theme.wsc.palette.neutral[300]};
      }
    }
  }

  .MuiInputLabel-root {
    ${(props) => props.theme.wsc.typography.body1};
    top: -70%;
    color: ${(props) => props.theme.wsc.palette.neutral[200]};
    transition: none;

    &.Mui-focused {
      display: none;
    }

    &.Mui-disabled {
      color: ${(props) => props.theme.wsc.palette.neutral[300]};
    }
  }
`;

export const StyledTextField = styled(TextField)`
  ${(props) =>
    Boolean(props.value) &&
    `
		.MuiInputLabel-root {
			display: none;
		}
	`}
`;
